import * as React from "react";
export default React.memo(function SvgLog(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" width={12} height={12} viewBox="0 0 12 12" role="presentation" {...props}><path fillRule="evenodd" d="M12 0H0v12h12zM9 3H3v1h6zM3 5h6v1H3zm6 2H3v1h6z" /></svg>;
});